import React from 'react';
import Styled from 'styled';
import classnames from 'classnames';

import SVGIcon from 'lib/images/svg-icon/svg-icon';

import iconArrowLeft from 'four-nets/icons/svg/icon_arrow-left.svg';
import iconArrowRight from 'four-nets/icons/svg/icon_arrow-right.svg';

import defaultStyles from './arrow-widget-button.scss';


interface Props {
    styles: typeof defaultStyles;
    onClick: () => any;
    hidden?: boolean;
    direction: string;
    onlyDesktop?: boolean;
    onlyMobile?: boolean;
}

const ArrowWidgetButton: React.FC<Props> = props => {
    const { styles, onClick, hidden, direction, onlyDesktop, onlyMobile } = props;

    return (
        <button
            onClick={onClick}
            className={classnames(styles.arrow, {
                [styles.hidden]: hidden,
                [styles.onlyDesktop]: onlyDesktop,
                [styles.onlyMobile]: onlyMobile,
            })}
        >
            <SVGIcon style={{image: styles.widgetIcon}} src={direction === 'right' ? iconArrowRight : iconArrowLeft} />
        </button>
    );
};

export default Styled(defaultStyles)(ArrowWidgetButton);
